/**
 * Created by Administrator on 2018/1/2.
 */
import { Component, OnInit, ViewChild } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Location } from "@angular/common";
import { HttpService } from "../service/http-service";
import { FileUpload } from "../service/file-upload";
import { CommonService } from "../service/common";
import { API } from "../config/api-config";
import  QRCode from "qrcode";
import * as moment from "moment";;
declare var $: any;
@Component({
  templateUrl: "./settingCourseEdit.html",
  styleUrls: ["./settingCourseEdit.component.css"],
})
export class SettingCourseEdit implements OnInit {
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private HttpService: HttpService,
    private location: Location,
    private fileupload: FileUpload,
    private common: CommonService
  ) {}
  @ViewChild('tagInput')  TagInputComponent:any
  public lecturerData = []
  private data: any = {
    active: 1,
    addressEn: "",
    addressTc: "",
    contentEn: "",
    contentTc: "",
    detailImageEn: "",
    detailImageTc: "",
    endTime: "",
    id: 0,
    imageEn: "",
    imageTc: "",
    latitude: 0,
    longitude: 0,
    placeEn: "",
    placeTc: "",
    enrollNum: 0,
    recommend: 0,
    regionEn: "",
    regionTc: "",
    startTime: "",
    storeNameEn: "",
    storeNameTc: "",
    titleEn: "",
    titleTc: "",
    type: "",
    lecturer: [],
    courseType:"",
    urlEn: "",
    urlTc: "",
    ranks: 0,
  };
  // 源data
  private originData: any = {
    active: 1,
    addressEn: "",
    addressTc: "",
    contentEn: "",
    contentTc: "",
    detailImageEn: "",
    detailImageTc: "",
    endTime: "",
    id: 0,
    imageEn: "",
    imageTc: "",
    latitude: 0,
    longitude: 0,
    placeEn: "",
    placeTc: "",
    enrollNum: 0,
    recommend: 0,
    regionEn: "",
    regionTc: "",
    startTime: "",
    storeNameEn: "",
    storeNameTc: "",
    titleEn: "",
    titleTc: "",
    type: "",
    lecturer: [],
    courseType:"",
    urlEn: "",
    urlTc: "",
    ranks: 0,
  };

  public autocompleteData = ["線上"];
  public courseTypeData = [];

  private id: number = 0;

  private isCreate: boolean = false;

  public signData = [];
  private imagePath: string = "";

  ngOnInit(): void {
    this.getSignData();

    this.getType();

    this.route.params.subscribe((params) => {
      this.id = params["id"];
      this.data.id = this.id;
    });

    if (this.id != 0) {
      this.getPath().then(() => {
        this.getData();
      });
    } else {
      this.isCreate = true;
      this.initTime();
      this.getPath();
    }
  }

  private initTime() {
    let self = this;
    setTimeout((res) => {
      $("#startTime")
        .datetimepicker({
          language: "zh-CN",
          format: "yyyy-mm-dd hh:ii",
          todayBtn: 1,
          autoclose: true,
          startDate: this.common.dateFormat(new Date(), "yyyy-MM-dd hh:mm"),
        })
        .on("changeDate", function (ev) {
          const now = new Date($("#startTime").val())
          const startNow = now.getFullYear() + '-' + (now.getMonth() + 1).toString().padStart(2, '0') + '-' + (now.getDate() + 1).toString().padStart(2, '0')
          $("#endTime").datetimepicker("setStartDate", $("#startTime").val());
          $("#endTime").datetimepicker("setEndDate", startNow);
          self.data.startTime = $(this).val();
        });

      $("#endTime")
        .datetimepicker({
          language: "zh-CN",
          format: "yyyy-mm-dd hh:ii",
          todayBtn: 1,
          autoclose: true,
          startDate: this.common.dateFormat(new Date(), "yyyy-MM-dd hh:mm")
        })
        .on("changeDate", function (ev) {
          $("#startTime").datetimepicker("setEndDate", $("#endTime").val());
          self.data.endTime = $(this).val();
        });
    });
  }

  //获取下拉列表
  private getSignData(): void {
    this.HttpService.getData(API.sign_in_select).then((res) => {
      this.signData = res.data;
    });
  }
  //获取全部数据
  private getData(): void {
    this.HttpService.getData(API.course + "/" + this.id).then((res) => {
      res.data.startTime = moment(res.data.startTime).format(
        "YYYY-MM-DD HH:mm"
      );
      res.data.endTime = moment(res.data.endTime).format("YYYY-MM-DD HH:mm");
      if (res.data.imageEn) {
        if (!/^http/.test(res.data.imageEn)) {
          res.data.imageEn = this.imagePath + res.data.imageEn;
        }
      }
      if (res.data.imageTc) {
        if (!/^http/.test(res.data.imageTc)) {
          res.data.imageTc = this.imagePath + res.data.imageTc;
        }
      }
      if (res.data.detailImageEn) {
        if (!/^http/.test(res.data.detailImageEn)) {
          res.data.detailImageEn = this.imagePath + res.data.detailImageEn;
        }
      }
      if (res.data.detailImageTc) {
        if (!/^http/.test(res.data.detailImageTc)) {
          res.data.detailImageTc = this.imagePath + res.data.detailImageTc;
        }
      }
      // this.lecturerData = res.data.lecturer
      this.lecturerData = res.data.lecturer!=''?res.data.lecturer.split(','):[]
      // this.lecturerData = ['213123', '123213', '234324', '234324']
      this.data = res.data;
      QRCode.toDataURL(res.data.qrCode).then(url => {
        this.data.qrCodeImg = url
      })
      .catch(err => {
        console.error(err)
      })
    });
  }

  // 获取图片路径
  private showImageEn: boolean = false;
  private showImageTc: boolean = false;
  private showDetailImageTc: boolean = false;
  private showDetailImageEn: boolean = false;
  private tempPath: string = API.getTemp;
  private upload(name: string) {
    let self = this;
    this.fileupload.upload(function (res) {
      let temRes = JSON.parse(res);
      if (temRes.status.code == 0) {
        switch (name) {
          case "imageEn":
            self.showImageEn = true;
            break;
          case "imageTc":
            self.showImageTc = true;
            break;
          case "detailImageEn":
            self.showDetailImageEn = true;
            break;
          case "detailImageTc":
            self.showDetailImageTc = true;
            break;
        }
        self.data[name] = temRes.data.fileName;
      }
    });
  }

  private getPath(): any {
    return this.HttpService.getData(API.resourcePath).then((res) => {
      this.imagePath = res.data;
      console.log(res.data);
    });
  }

  private submit(): void {
    let data = this.data;

    data.startTime = moment(data.startTime);
    data.endTime = moment(data.endTime);
    for (let k in data) {
      if (!this.originData.hasOwnProperty(k)) {
        delete data[k];
      }
    }
    data.imageTc = data.imageTc.replace(this.imagePath, "");
    data.imageEn = data.imageEn.replace(this.imagePath, "");
    data.detailImageEn = data.detailImageEn.replace(this.imagePath, "");
    data.detailImageTc = data.detailImageTc.replace(this.imagePath, "");
    console.log(data);
    delete data.updatedTime;
    delete data.updatedBy;
    delete data.createdTime;
    delete data.createdBy;
    this.HttpService.postData(API.course, data).then((res) => {
      let data = res;
      if (data.status.code == 0 || data.status.code == "0") {
        this.location.back();
      } else {
        alert(data.status.message);
      }
    });
  }

  private getType() {
    this.HttpService.getData(API.courseType).then((res) => {
      if (res.data.indexOf("線上") < 0) {
        this.autocompleteData = [...res.data, ...this.autocompleteData];
      } else {
        this.autocompleteData = res.data;
      }
      let recommendIndex = res.data.indexOf("推薦");
      if (recommendIndex >= 0) {
        this.autocompleteData.splice(recommendIndex, 1);
      }
    });

    this.HttpService.getData(API.courseTypeList).then((res) => {
      this.courseTypeData = res.data;
    });
  }
  private inputDataChange(val) { 
    this.data.lecturer = val
    console.log(this.data.lecturer)
  }
  private tagInputClick() { 
    this.TagInputComponent.keyup(this.TagInputComponent.keyupData)
  }
}



// WEBPACK FOOTER //
// /data/jenkins_data/workspace/NaturallyPlus_WEB_UAT/src/app/activity/settingCourseEdit.component.ts